// Lightweight slug lists for the ROUTER only. Kept separate from the full
// content data modules so the eager (hydrated) public bundle does not pull in
// hundreds of KB of copy that is only rendered by lazy-loaded routes.
// IMPORTANT: keep in sync with guidePagesAr.js (AR_GUIDE_SLUGS) and
// legalContent.js (LEGAL_CONTENT_SLUGS).

export const AR_GUIDE_SLUGS = [
  "what-is-snagging-dubai",
  "snagging-vs-handover-vs-dlp",
  "snagging-cost-dubai-2026",
  "room-by-room-snagging-checklist",
  "when-to-book-snagging-inspection",
  "send-snagging-report-to-developer",
  "villa-vs-apartment-snagging",
  "dlp-warranty-11-month-inspection",
];

export const LEGAL_CONTENT_SLUGS = ["cancellation-refund-policy", "inspection-scope-exclusions", "privacy-policy", "limitation-of-liability"];
